
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legalPage/[legalPage]",
      function () {
        return require("private-next-pages/legalPage/[legalPage]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legalPage/[legalPage]"])
      });
    }
  